module.exports = __webpack_public_path__ + "assets/img/icon-badge-23943466.png";